import React, { useEffect, useState } from "react";
import Header from "../Shared/Header";
import Sidemenu from "../Shared/Sidemenu";
import { useLocation } from "react-router-dom";
import priorityIcon from "../../Assets/Images/Rpm/Red.svg";
import priorityIcon1 from "../../Assets/Images/Rpm/Yellow.svg";
import priorityIcon2 from "../../Assets/Images/Rpm/Green.svg";
import { APP_ROUTES } from "../../PageRouting/approutes";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import {
  GETCRITICALITYCOUNT,
  getCriticalityCount,
  setCriticalityType,
} from "../../Redux/actions/CriticalityActions";
import { RiArrowLeftSFill } from "react-icons/ri";
import { IoMdArrowDropup } from "react-icons/io";
import users from "../../Assets/Images/users.png";

const Layouts = ({ children }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const criticality = useSelector((state) => state.criticality.countObject);
  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;
  const [imgLoaded, setImgLoaded] = useState({
    critical: false,
    abnormal: false,
    normal: false,
  });

  const getCriticalCountFromAction = async () => {
    if (loginResultObject.user.rpmApplicable === "Y") {
      let countStatus = dispatch(getCriticalityCount());
    }
  };

  useEffect(() => {
    getCriticalCountFromAction();
  }, []);

  const handleSideBarMenu = () => {
    setMenuOpen((prevState) => !prevState);
  };

  useEffect(() => {
    if (location.pathname === "/videocall") {
      setMenuOpen(false);
    }
  }, []);

  const handlePatientMonitoring = (type) => {
    dispatch(setCriticalityType(type));
    history.push(APP_ROUTES.PATIENTMONITORING);
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen((prev) => !prev);
  };

  return (
    <div className="h-screen flex flex-col bg-[#F1FFF9]">
      <Header handleSideBarMenu={handleSideBarMenu} />
      <div className="md:flex gap-1 flex-1 overflow-hidden">
        <div
          className={`${
            isMenuOpen ? "w-[14%]" : "w-[4%]"
          } md:block hidden overflow-y-auto transition-all scrollWidth`}
        >
          <div className="space-y-2 rounded-r-lg border-t border-r bg-white h-screen">
            <Sidemenu
              isMenuOpen={isMenuOpen}
              handleSideBarMenu={handleSideBarMenu}
            />
          </div>
        </div>
        <div
          className={`${
            isMenuOpen ? "md:w-[85%] w-full" : "w-[95%]"
          } flex-1 p-1 md:p-2 lg:p-3 overflow-y-auto bg-white border rounded-lg`}
        >
          {/* {loginResultObject.user.rpmApplicable === "Y" &&
            location.pathname !== APP_ROUTES.PATIENTMONITORING && (
              <div className="flex flex-wrap justify-center items-center my-2">
                <div
                  onClick={() => handlePatientMonitoring("2")}
                  className="flex items-center mx-3 bg-white rounded-3xl text-[#FF3022] text-sm border border-[#FF3022] pr-3 cursor-pointer"
                >
                  <div className="bg-[#FF3022] py-1 px-3 mr-3 rounded-full w-[40px] h-[30px] flex justify-center items-center">
                    {!imgLoaded.critical && (
                      <div className="w-[20px] h-[20px] rounded-full bg-white animate-pulse" />
                    )}
                    <img
                      src={priorityIcon}
                      width="20px"
                      style={{ display: imgLoaded.critical ? "block" : "none" }}
                      onLoad={() =>
                        setImgLoaded((prev) => ({ ...prev, critical: true }))
                      }
                      alt="critical icon"
                    />
                  </div>
                  Critical Patients (
                  {criticality?.Total_Critical_Patient_Count || 0})
                </div>

                <div
                  onClick={() => handlePatientMonitoring("1")}
                  className="flex items-center mx-3 bg-white rounded-3xl text-[#FFA12C] text-sm border border-[#FFA12C] pr-3 cursor-pointer"
                >
                  <div className="bg-[#FFA12C] py-1 px-3 mr-3 rounded-full w-[40px] h-[30px] flex justify-center items-center">
                    {!imgLoaded.abnormal && (
                      <div className="w-[20px] h-[20px] rounded-full bg-white animate-pulse" />
                    )}
                    <img
                      src={priorityIcon1}
                      width="20px"
                      style={{ display: imgLoaded.abnormal ? "block" : "none" }}
                      onLoad={() =>
                        setImgLoaded((prev) => ({ ...prev, abnormal: true }))
                      }
                      alt="abnormal icon"
                    />
                  </div>
                  Abnormal Patients (
                  {criticality?.Total_Abnormal_Patient_Count || 0})
                </div>
                <div
                  onClick={() => handlePatientMonitoring("0")}
                  className="flex items-center mx-3 bg-white rounded-3xl text-[#00B24B] text-sm border border-[#00B24B] pr-3 cursor-pointer"
                >
                  <div className="bg-[#00B24B] py-1 px-3 mr-3 rounded-full w-[40px] h-[30px] flex justify-center items-center">
                    {!imgLoaded.normal && (
                      <div className="w-[20px] h-[20px] rounded-full bg-white animate-pulse" />
                    )}
                    <img
                      src={priorityIcon2}
                      width="20px"
                      style={{ display: imgLoaded.normal ? "block" : "none" }}
                      onLoad={() =>
                        setImgLoaded((prev) => ({ ...prev, normal: true }))
                      }
                      alt="normal icon"
                    />
                  </div>
                  Normal Patients (
                  {criticality?.Total_Normal_Patient_Count || 0})
                </div>
              </div>
            )} */}
          <div
            className="critical"
            style={{ marginTop: "8rem" }}
            onClick={toggleDrawer}
          >
            <p className="critical-p">
              <div className="critical-icon-dashboard">
                <IoMdArrowDropup className="text-[#F46257] w-6 h-6" />
              </div>
            </p>
          </div>
          {loginResultObject.user.rpmApplicable === "Y" && isDrawerOpen && (
            <div className="fixed top-60 right-6 h-80 w-36 bg-white border-[#D3D3D3] border rounded-lg shadow-lg p-4 z-50">
              <div>
                <div
                  className="flex flex-col items-center gap-2"
                  onClick={() => handlePatientMonitoring("2")}
                >
                  <div className="w-10 h-10 rounded-full bg-[#FF3022] flex items-center justify-center">
                    <img src={users} alt="" className="w-6 h-6" />
                  </div>
                  <label className="text-xs font-sans font-medium">
                    Critical Patients
                  </label>
                  <p className="text-xs font-inter font-medium">
                    ({criticality?.Total_Critical_Patient_Count || 0})
                  </p>
                </div>
                <div
                  className="flex flex-col items-center gap-2"
                  onClick={() => handlePatientMonitoring("1")}
                >
                  <div className="w-10 h-10 rounded-full bg-[#00B24B] flex items-center justify-center">
                    <img src={users} alt="" className="w-6 h-6" />
                  </div>
                  <label className="text-xs font-sans font-medium">
                    Abnormal Patients
                  </label>
                  <p className="text-xs font-inter font-medium">
                    ({criticality?.Total_Abnormal_Patient_Count || 0})
                  </p>
                </div>
                <div
                  className="flex flex-col items-center gap-2"
                  onClick={() => handlePatientMonitoring("0")}
                >
                  <div className="w-10 h-10 rounded-full bg-[#FFA12C] flex items-center justify-center">
                    <img src={users} alt="" className="w-6 h-6" />
                  </div>
                  <label className="text-xs font-sans font-medium">
                    Normal Patients
                  </label>
                  <p className="text-xs font-inter font-medium">
                    ({criticality?.Total_Normal_Patient_Count || 0})
                  </p>
                </div>
              </div>
            </div>
          )}
          <div className="space-y-4">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Layouts;
